import html2canvas from "html2canvas";

export const prepareNode = (node, extraStyles = {}) => {
    const original = {
        maxHeight: node.style.maxHeight,
        overflow: node.style.overflow,
        overflowY: node.style.overflowY,
        height: node.style.height,
        width: node.style.width,
        position: node.style.position,
        transform: node.style.transform,
        zIndex: node.style.zIndex,
        ...extraStyles
    };

    node.style.maxHeight = 'none';
    node.style.overflow = 'visible';
    node.style.overflowY = 'visible';
    node.style.height = 'auto';
    node.style.position = 'static';
    node.style.transform = 'none';
    node.style.zIndex = '1';

    return original;
};

export const restoreNode = (node, originalStyles) => {
    Object.keys(originalStyles).forEach(key => {
        if (originalStyles[key] !== undefined) {
        node.style[key] = originalStyles[key];
        }
    });
};

export const captureNode = async (node) => {
    return html2canvas(node, {
        backgroundColor: "white",
        useCORS: true,
        allowTaint: true,
        scale: 2,
        scrollX: 0,
        scrollY: 0,
        windowWidth: node.scrollWidth,
        windowHeight: node.scrollHeight
    });
};